import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { leseThema, setzeThema } from './lib/thema';
import { istDunkel, leseDunkelmodus, setzeDunkelmodus } from './lib/dunkelmodus';
// Nach App geladen, damit die Themen-Regeln die Altdateien überschreiben
// können. Sie sind zusätzlich spezifischer geschrieben, weil nachgeladene
// Seiten ihr eigenes CSS später mitbringen.
import './styles/themes.css';

// Ansicht vor dem ersten Rendern setzen, sonst blitzt kurz die Vorgabe auf.
setzeThema(leseThema());

// Helligkeit vor dem ersten Rendern setzen, damit sie über Routen und über
// das Neuladen hinweg gilt.
setzeDunkelmodus(leseDunkelmodus());

// Hell/Dunkel und Ansicht über Tabs hinweg gleich halten
window.addEventListener('storage', (event) => {
  if (event.key === 'theme') {
    setzeDunkelmodus(istDunkel(event.newValue));
  }
  if (event.key === 'thema') {
    setzeThema(leseThema());
  }
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // Creates a root to render your app
root.render(<App />);
